import { render, staticRenderFns } from "./End.vue?vue&type=template&id=351f772e&scoped=true&"
import script from "./End.vue?vue&type=script&lang=js&"
export * from "./End.vue?vue&type=script&lang=js&"
import style0 from "../../assets/flow-design.css?vue&type=style&index=0&id=351f772e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f772e",
  null
  
)

export default component.exports